import { createFunctionLibrary } from '../functionLibrary'
import { FeaturesModelInstance, SiteAssetsModule } from '../types/becky'
import { typedModelFactory } from './helpers/typedModelFactory'
import { resolveBeckyModel } from './helpers/resolveBeckyModel'
import getPayloadWithErrorPage from '../errorPages/getPayloadWithErrorPage'
import byRefModule from '../byRef'
import { withBeckyCache } from './utils/withBeckyCache'
import { getBeckyTopology } from './helpers/topologyBuilder'

export const featuresModelFactory = typedModelFactory<FeaturesModelInstance>(require('../carmi/features.carmi'))

const featuresModule: SiteAssetsModule<FeaturesModelInstance> = (moduleContext) => {
	const { httpClient, metricsReporter, topologyGetter, moduleFetcher } = moduleContext
	const funcLib = createFunctionLibrary({
		fetch: withBeckyCache(httpClient.fetch, metricsReporter),
		metricsReporter,
	})

	return {
		execute: async (payload) => {
			payload = payload.errorPageId ? getPayloadWithErrorPage(payload) : payload
			const payloadWithResolvedRefs = await byRefModule(moduleContext).execute(payload)
			const beckyModel = await resolveBeckyModel({
				payload: payloadWithResolvedRefs,
				beckyTopology: getBeckyTopology(topologyGetter, payload),
				moduleFetcher,
				httpClient,
			})
			const { runAsyncAndReport } = funcLib
			return runAsyncAndReport(
				() => new Promise((done) => featuresModelFactory(beckyModel, { ...funcLib, done })),
				'tb-features-model-calculation'
			)
		},
	}
}

export default featuresModule
